/* unplugin-vue-components disabled */import { render } from "./TeacherList.vue?vue&type=template&id=8be5bd32&scoped=true"
import script from "./TeacherList.vue?vue&type=script&lang=js"
export * from "./TeacherList.vue?vue&type=script&lang=js"

import "./TeacherList.vue?vue&type=style&index=0&id=8be5bd32&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户湖南中医药大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be5bd32"]])

export default __exports__